/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 05-11-2026 12:02:02

export enum CohortrendementTotDoublure {
    ZONDER_VERTRAGING = "Zonder vertraging",
    ZONDER_VERTRAGING_PROGNOSE = "Zonder vertraging (prognose)",
    GEDOUBLEERD = "Gedoubleerd",
    GEDOUBLEERD_PROGNOSE = "Gedoubleerd (prognose)"
}
